import { Component, Inject, Optional } from '@angular/core';
import { ModalOverlayRef } from 'src/app/modal/modal-overlay-ref';
import { MODAL_DATA } from '../../modal/modal.service';

@Component({
    selector: 'gl-shared-changes-popup',
    templateUrl: './shared-changes-popup.component.html',
    styleUrls: ['./shared-changes-popup.component.scss'],
    standalone: false
})
export class SharedChangesPopupComponent {
  public lastUser = '';

  constructor(
    private modalRef: ModalOverlayRef,
    @Optional() @Inject(MODAL_DATA) public data: string,
  ) {
    this.lastUser = data;
    this.modalRef.backgroundClicked();
  }

  public saveChanges(): void {
    this.close('saveChanges');
  }

  public viewChanges(): void {
    this.close('viewChanges');
  }

  public close(msg: string): void {
    this.modalRef.close({ data: msg });
  }
}
